import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaLightbulb, FaChartLine, FaUsers, FaGlobe } from 'react-icons/fa';
import './Benefits.css';
import { motion } from 'framer-motion';
import { staggerContainer, item, fadeInUp } from '../../styles/animations';

const Benefits = () => {
  const benefits = [
    {
      icon: <FaLightbulb />,
      title: "Innovative Solutions",
      description: "We deliver cutting-edge technology solutions tailored to your business needs."
    },
    {
      icon: <FaChartLine />,
      title: "Business Growth",
      description: "Our strategies are designed to accelerate your business growth and maximize ROI."
    },
    {
      icon: <FaUsers />,
      title: "Expert Team",
      description: "Our team of experienced professionals brings diverse expertise to every project."
    },
    {
      icon: <FaGlobe />,
      title: "Global Reach",
      description: "We provide services worldwide, helping businesses expand their global footprint."
    }
  ];

  return (
    <section className="benefits-section">
      <Container>
        <motion.div className="section-heading text-center" variants={fadeInUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>
          <span className="subtitle">Our Benefits</span>
          <h2>Solutions That Drive Success</h2>
          <p className="section-description">
            We offer comprehensive solutions designed to address your business challenges and drive sustainable growth.
          </p>
        </motion.div>

        <motion.div className="row g-4" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{ once: true }}>
          {benefits.map((benefit, index) => (
            <Col lg={3} md={6} key={index}>
              <motion.div className="benefits-card " variants={item} whileHover={{ scale: 1.02 }}>
                <Card.Body className="text-center">
                  <div className="benefits-icon">
                    {benefit.icon}
                  </div>
                  <Card.Title className="benefit-title">{benefit.title}</Card.Title>
                  <Card.Text className="benefit-description">
                    {benefit.description}
                  </Card.Text>
                </Card.Body>
              </motion.div>
            </Col>
          ))}
        </motion.div>
      </Container>
    </section>
  );
};

export default Benefits;